module.exports = __webpack_public_path__ + "img/network-mobile.effcc41e.jpg";